import React from 'react';
import EmptyState from '../empty-state/EmptyState';
import PropTypes from 'prop-types';
import { Table, UncontrolledTooltip } from 'reactstrap';
import moment from 'moment';
import InfoOutlined from '@mui/icons-material/InfoOutlined';

export const IncidentsTable = ({ incidents }) => {

  if (incidents.length === 0) {
    return (
        <EmptyState 
            title="No hay incidentes para mostrar" 
            description="Todas las tiendas están actualizando sus datos correctamente."
            icon="📋"
        />
    );
  }

  return (
    <div className="incidents-table-container">
      <Table responsive hover className="incidents-table">
        <thead>
          <tr>
            <th>Tienda con incidente</th>
            <th>
              <div className="header-with-tooltip">
                Último Mensaje
                <span id="last-message-tooltip" className="header-with-tooltip__icon">
                  <InfoOutlined />
                </span>
                <UncontrolledTooltip
                  placement="top"
                  target="last-message-tooltip"
                  boundariesElement="window"
                  delay={0}
                >
                  Esto es lo que Customer Success quiere comunicarte para dar más contexto del incidente
                </UncontrolledTooltip>
              </div>
            </th>
            <th>Estado Publicado</th>
          </tr>
        </thead>
        <tbody>
          {incidents.map((incident) => (
            <tr key={incident.incidentId}>
              <td className="store-cell">
                <div className="store-info">
                    <div className="store-info__name">{incident.storeName}</div>
                    
                </div>
              </td>
              <td className="message-cell">
                 {incident.lastMessage && (
                    <div className="incident-message">
                        <div className="incident-message__date">
                          Publicado:
                          <span className="incident-message__relative-time">
                            {incident.lastUpdate && moment.utc(incident.lastUpdate).locale('es').fromNow()}
                          </span>
                        </div>
                        <div className="incident-message__text">{incident.lastMessage}</div>
                    </div>
                )}
              </td>
              <td className="status-cell">
                <span
                    className="incident-status-badge"
                    data-incident-status={incident.statusId}>
                    {incident.statusName}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

IncidentsTable.propTypes = {
  incidents: PropTypes.arrayOf(
    PropTypes.shape({
      incidentId: PropTypes.number.isRequired,
      storeName: PropTypes.string.isRequired,
      statusId: PropTypes.number.isRequired,
      statusName: PropTypes.string.isRequired,
      lastUpdate: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
      lastMessage: PropTypes.string.isRequired
    })
  ).isRequired,
  enableManagement: PropTypes.bool
};

export default IncidentsTable;